export const ActivePointSdek = () => (
	<svg width="115" height="124" viewBox="0 0 115 124" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g filter="url(#filter0_ddd_25188_21645)">
			<path
				d="M85.793 62.375C85.793 83.2188 61.793 95 61.793 95C61.793 95 37.793 82.7656 37.793 62.375C37.793 48.3608 48.5381 37 61.793 37C75.0478 37 85.793 48.3608 85.793 62.375Z"
				fill="white"
			/>
		</g>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M63.3694 66.6944H60.0844C54.9599 66.6944 58.6829 55.3285 62.9971 55.3285H68.1873C69.0195 55.3285 70.4867 55.4886 71.2095 53.3389L72.3263 50H65.2089C61.3546 50 58.3544 51.4179 56.1863 53.7963C52.4415 57.8669 51.1713 64.2245 52.0692 67.2661C52.9233 70.079 55.2446 71.9314 58.8799 71.9772L61.705 72H65.187L66.0411 69.3243C66.6762 67.4262 65.2528 66.6944 63.3694 66.6944Z"
			fill="#1AB248"
		/>
		<defs>
			<filter
				id="filter0_ddd_25188_21645"
				x="0.792969"
				y="0"
				width="114"
				height="124"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB">
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="8" />
				<feGaussianBlur stdDeviation="5" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.1 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_25188_21645" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="4" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.05 0" />
				<feBlend mode="normal" in2="effect1_dropShadow_25188_21645" result="effect2_dropShadow_25188_21645" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx="-4" dy="-4" />
				<feGaussianBlur stdDeviation="16.5" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
				<feBlend mode="normal" in2="effect2_dropShadow_25188_21645" result="effect3_dropShadow_25188_21645" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_25188_21645" result="shape" />
			</filter>
		</defs>
	</svg>
)
